import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { siopColors } from '../../config/theme';

/**
 * ScopeInfo — the (i) at the right of the workspace tab row. Opens a short
 * "Scope of this view" note: what the page shows, which filters apply, and
 * where the figures come from. Renders nothing when the page has no note, so
 * an unlisted route never shows an empty popover.
 */
const ScopeInfo = ({ lines }) => {
  const [anchor, setAnchor] = useState(null);
  if (!lines?.length) return null;
  const open = Boolean(anchor);

  return (
    <>
      <IconButton
        size="small"
        aria-label="Scope of this view"
        aria-expanded={open}
        onClick={(e) => setAnchor(open ? null : e.currentTarget)}
        sx={{ color: open ? siopColors.primary : siopColors.grey, flexShrink: 0 }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { p: 2, maxWidth: 380, borderRadius: 2 } } }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: 13, color: siopColors.navy, mb: 1 }}>
          Scope of this view
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.25, display: 'grid', gap: 0.75 }}>
          {lines.map((line) => (
            <Typography component="li" key={line} sx={{ fontSize: 12.5, color: '#404040' }}>
              {line}
            </Typography>
          ))}
        </Box>
      </Popover>
    </>
  );
};

ScopeInfo.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.string),
};

export default ScopeInfo;
